import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {deleteRoute} from 'lib/api/routes'
import {errorMessage} from 'lib/styleguide/base.scss'

export const DELETE_DIALOG = 'DELETE_DIALOG'

export class DeleteDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      deletePending: false,
      deleteError: false
    }
  }

  onConfirm = () => {
    const {route, deleteRoute} = this.props
    this.setState({deletePending: true})

    deleteRoute(route.id)
      .then(() => { window.location = '/' }) // todo - html5 push to Dashboard when that's rolled out
      .catch(() => this.setState({deletePending: false, deleteError: true}))
  }

  render () {
    const {route, onRequestClose} = this.props
    const {deletePending, deleteError} = this.state

    return (
      <ConfirmationDialog
        primary danger
        title={<Fragment>Delete <strong>{route.name}</strong>?</Fragment>}
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={deletePending}
        confirmText={`Permanently Delete Route`}>
        <p>
          Are you sure you want to delete your route, <strong>{route.name}</strong>?
          <br />This action cannot be undone.
        </p>
        {deleteError && <div className={errorMessage}>
          Oops, we encountered an error while deleting this route. Please try again.
        </div>}
      </ConfirmationDialog>
    )
  }
}

export const DeleteDialogContainer = connect(
  null,
  {deleteRoute}
)(DeleteDialog)
